import {Form} from 'antd';

import {FormActiveMark} from '../../../../../../component/form-active-mark/form-active-mark';
import {FormItemRadio} from '../../../../../../component/form-item-radio/form-item-radio';
import {Locale} from '../../../../../../provider/locale/locale';
import {ReviewTagsTreeSelect} from '../review-tree-select/review-tags-tree-select';
import * as styles from '../reviews-filter.scss';
import {WITHOUT_TAGS_OPTIONS} from '../reviews-filter-const';
import {ReviewsFilterDataType, ReviewsFilterFieldNameEnum, WithoutTagEnum} from '../reviews-filter-type';

type PropsType = {
    form: ReturnType<typeof Form.useForm>[0];
    reviewFilterState: ReviewsFilterDataType;
    isShowAutotags: boolean;
    onWithoutTagChange: (value: WithoutTagEnum) => void;
    onNewTagsChange: (value: Array<number | string>) => void;
};

export function ReviewsFilterSectionTags(props: PropsType): JSX.Element {
    const {form, reviewFilterState, isShowAutotags, onWithoutTagChange, onNewTagsChange} = props;

    return (
        <>
            <FormItemRadio<WithoutTagEnum>
                className={styles.ReviewsFilter_selectFilter}
                fieldStateValue={reviewFilterState[ReviewsFilterFieldNameEnum.withoutTag]}
                form={form}
                label={<Locale stringKey="REVIEWS__FILTER__LABEL__TAGS" />}
                name={ReviewsFilterFieldNameEnum.withoutTag}
                onClick={onWithoutTagChange}
                options={WITHOUT_TAGS_OPTIONS}
            />

            <div className={styles.ReviewsFilter_selectFilter}>
                <FormActiveMark isVisible={reviewFilterState[ReviewsFilterFieldNameEnum.tagList].length > 0} />
                <Form.Item
                    initialValue={reviewFilterState[ReviewsFilterFieldNameEnum.tagList]}
                    label={<Locale stringKey="REVIEWS__FILTER__LABEL__INCLUDES_TAGS" />}
                    name={ReviewsFilterFieldNameEnum.tagList}
                >
                    <ReviewTagsTreeSelect
                        defaultValue={reviewFilterState[ReviewsFilterFieldNameEnum.tagList]}
                        disabled={
                            reviewFilterState[ReviewsFilterFieldNameEnum.withoutTag] === WithoutTagEnum.withoutTagTrue
                        }
                        isShowAutotags={isShowAutotags}
                        onConfirm={onNewTagsChange}
                    />
                </Form.Item>
            </div>
        </>
    );
}
